import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
	selector: 'app-light-checkbox',
	templateUrl: './light-checkbox.component.html',
	styleUrls: ['./light-checkbox.component.scss'],
})
export class LightCheckboxComponent implements OnInit {
	@Input() value: any = '';
	@Input() text: string = '';
	@Input() checked: boolean = false;
	@Input() disabled: boolean;

	@Output() onChangeEvent = new EventEmitter<any>();

	constructor() {
	}

	ngOnInit(): void {
	}

	onChange(event): void {
		if (event.checked && this.value) {
			this.onChangeEvent.emit(this.value);
		} else {
			this.onChangeEvent.emit(event.checked);
		}
	}
}
